import { useContext } from 'react';
import { AxiosContext } from './AxiosContext';

const useAxios = () => useContext(AxiosContext);

export default useAxios;
